export const CanCloseMixin = (superClass) => class extends superClass {
    constructor() {
        super(...arguments);
        this.patchClose = true;
        this._close = null;
    }
    close() {
        // @ts-expect-error This should blow up so users implement the mixin
        this._close();
    }
};
export const ProvidesCanCloseToSlotsMixin = (superClass) => class extends superClass {
    // HACK: slot-props don't seem to exist and neither does the context pattern for this
    handleSlotChange(evt) {
        // @ts-ignore
        const children = evt.target.assignedNodes({ flatten: true });
        // @ts-ignore
        for (const child of children.filter((e) => e.patchClose)) {
            // @ts-expect-error users have to implement the close method
            child._close = () => this.close();
        }
    }
};
//# sourceMappingURL=util.js.map